export class DtoUsuario {
    Identificacion: string = '';
    Apellidos: string = '';
    Nombres: string = '';
    Fecha: Date = new Date();
}